export { default as GetInspiredSection } from './get-inspired';
